import {JSONSchemaType} from 'ajv'

export interface SecondeVieNotificationBean {
  phoneNumber: string
  message: string
  redirectUrl: string
}

export const secondeVieNotificationSchema: JSONSchemaType<SecondeVieNotificationBean> = {
  type: 'object',
  properties: {
    phoneNumber: {
      type: ['string']
    },
    message: {
      type: ['string']
    },
    redirectUrl: {
      type: ['string']
    }
  },
  required: ['phoneNumber', 'message', 'redirectUrl'],
  additionalProperties: true
}
